// ─────────────────────────────────────────────────────────────────────────────
// Memória dos avisos de retorno já dados.
//
// A regra do alerta de agendamento mudou: ele sai UMA VEZ por ticket, e não a
// cada três minutos. Só que "uma vez" não pode significar "uma vez por sessão"
// — recarregar a página traria de volta o alerta de tudo o que já foi avisado,
// que é exatamente a reclamação que originou a mudança.
//
// Então o registro sai da memória e vai para o disco.
//
// POR QUE localStorage NOS DOIS AMBIENTES
//
// O resto da configuração do Orion passa por `services/plataforma.js`, que no
// desktop escreve um config.json via IPC e devolve os dados por EVENTO — a
// leitura direta não funciona lá (`config.ler()` responde `null` no Electron).
// Para decidir se um alerta sai ou não, a leitura precisa ser síncrona e
// imediata.
//
// O `localStorage` resolve isso e vale nos dois: no navegador é o de sempre, e
// no Electron o renderer é um Chromium com armazenamento próprio, gravado na
// pasta de dados do app e preservado entre execuções. É por máquina, que é
// justamente o alcance combinado.
// ─────────────────────────────────────────────────────────────────────────────

import { identidadeDoAviso } from './filaRetorno';

/** Prefixo da chave. O código do operador entra no fim: uma máquina, vários. */
const PREFIXO = 'orion:avisos-retorno';

/** Depois disto, o registro é lixo: o agendamento já passou faz tempo. */
const VALIDADE_DIAS = 7;

const chaveDe = (codigoOperador) => `${PREFIXO}:${codigoOperador || 'sem-codigo'}`;

/**
 * Lê o registro do disco: { [identidade]: instante em ms }.
 *
 * Devolve objeto vazio em qualquer problema — armazenamento bloqueado, JSON
 * corrompido, janela anônima. Perder o registro faz o Orion avisar de novo, que
 * é chato; travar por causa dele seria pior.
 */
export function carregarAvisos(codigoOperador) {
  try {
    const bruto = localStorage.getItem(chaveDe(codigoOperador));
    const dados = bruto ? JSON.parse(bruto) : {};
    return (dados && typeof dados === 'object' && !Array.isArray(dados)) ? dados : {};
  } catch (e) {
    return {};
  }
}

/** Grava o registro inteiro. Silencioso em caso de falha, pelo mesmo motivo. */
export function salvarAvisos(codigoOperador, avisos) {
  try {
    localStorage.setItem(chaveDe(codigoOperador), JSON.stringify(avisos || {}));
  } catch (e) { /* cota estourada ou armazenamento bloqueado */ }
}

/**
 * Descarta o que passou da validade.
 *
 * Sem isto o registro cresceria para sempre: cada agendamento de cada dia
 * deixaria a sua linha, e nenhuma delas volta a ser consultada depois que o
 * ticket sai da fila.
 */
export function limparAntigos(avisos, agora = Date.now()) {
  const limite = agora - VALIDADE_DIAS * 24 * 60 * 60 * 1000;
  const limpo = {};
  for (const [id, instante] of Object.entries(avisos || {})) {
    if (Number.isFinite(instante) && instante >= limite) limpo[id] = instante;
  }
  return limpo;
}

/** True quando este ticket, com este agendamento, já recebeu o alerta. */
export function jaAvisado(avisos, ticket) {
  const id = identidadeDoAviso(ticket);
  return id != null && avisos?.[id] != null;
}
